module.exports = __webpack_public_path__ + "media/images/treatment-guide-social-e7471f43d98c0d3d96dc38e14b7d865d.png";